import { render, staticRenderFns } from "./BulkDeleteButton.vue?vue&type=template&id=5f491a1a&"
import script from "./BulkDeleteButton.vue?vue&type=script&lang=js&"
export * from "./BulkDeleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports